<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">电梯大数据监管平台</h3>
      </div>

      <el-form-item prop="accountId">
        <span class="svg-container">
          <img src="../../static/icon-login-user.png" />
        </span>
        <el-input
          ref="accountId"
          v-model="loginForm.accountId"
          placeholder="请输入账号"
          name="accountId"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <el-form-item prop="password">
          <span class="svg-container">
            <img src="../../static/icon-login-pwd.png" />
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <!-- <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /> -->
          </span>
        </el-form-item>
      </el-tooltip>
      <el-button
        type="primary"
        style="width: 100%; margin-bottom: 30px"
        @click.native.prevent="handleLogin"
        >登录</el-button
      >
    </el-form>

    <el-dialog
      title="选择机构"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div
        v-for="item in orgList"
        :key="item.index"
        class="org-item"
        @click="selectOrg(item)"
      >
        <span class="org-item-left"
          >{{ item.orgTypeName }}--{{ item.orgName }}</span
        >
        <span class="org-item-right">点击选择</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelOrg()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    const validateAccountId = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        accountId: '',
        password: '',
        ClientId: 'web.dashboard',
      },
      loginRules: {
        accountId: [
          { required: true, trigger: 'blur', validator: validateAccountId },
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword },
        ],
      },
      passwordType: 'password',
      capsTooltip: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      dialogVisible: false,
      orgList: [],
      cityNameList: [],
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (
      sessionStorage.getItem('isLogin') != null &&
      sessionStorage.getItem('isLogin') === '1'
    ) {
      this.$router.push({ path: '/' })
    } else {
      if (this.loginForm.accountId === '') {
        this.$refs.accountId.focus()
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus()
      }
    }
  },
  methods: {
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= 'a' && key <= 'z') ||
          (!shiftKey && key >= 'A' && key <= 'Z')
        ) {
          this.capsTooltip = true
        } else {
          this.capsTooltip = false
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.axios
            .post(process.env.API_ROOT + '/passport/login', this.loginForm)
            .then((res) => {
              if (res.data.successed) {
                window.sessionStorage.setItem('token', res.data.result)
                this.getOrgList()
              } else {
                this.$message.error(res.data.message)
                this.loginForm.password = ''
                this.$refs.password.focus()
              }
            })
            .catch((err) => {
              this.$message.error('登录失败')
            })
        } else {
          this.$message.error('账号密码输入有误！')
          return false
        }
      })
    },
    getOrgList() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Organization/user/org',
      })
        .then((res) => {
          if (res.status === 200) {
            this.dialogVisible = true
            this.orgList = res.data.result
          }
        })
        .catch((err) => {})
    },
    selectOrg(item) {
      this.dialogVisible = false
      sessionStorage.setItem('isLogin', 1)
      sessionStorage.setItem('orgId', item.orgId)
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/v2/visual/org/citytype',
      }).then((res) => {
        this.cityNameList = res.data.result
        console.log(res.data.result)
        // this.cityNameList = res.data.result.userCityType
        // for (var i = 0; i < this.cityNameList.length; i++) {
        // if (this.cityNameList[i].isDefault) {
        sessionStorage.setItem('cityName', this.cityNameList.cityName)
        sessionStorage.setItem('cityId', this.cityNameList.cityId)
        sessionStorage.setItem('regionType', this.cityNameList.cityType)
        this.$router.push({
          name: 'Home',
          params: {
            orgId: item.orgId,
          },
        })
        // }
        // }
      })
    },

    cancelOrg() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
  },
}
</script>
<style lang="scss" scoped>
$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 0px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>
<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  height: calc(100% - 40px);
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 160px 35px;
    margin: 0 auto;
    overflow: hidden;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 3px 5px 0px 0px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    height: 44px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }
  .org-item {
    border-radius: 10px;
    line-height: 26px;
    background: #2c3e50;
    color: #ffffff;
    margin-top: 10px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    .org-item-left {
      margin-left: 20px;
    }
    .org-item-right {
      line-height: 26px;
      margin-right: 20px;
      color: #dadbdc;
      font-size: 12px;
    }
  }
  .org-item:hover {
    background: #337bb1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue